import { useLayoutEffect } from 'react';
import { usePageData } from 'state/pageData';
import { useWidget } from 'state/widget/context';
import { injectVariantId } from 'utils/injection';

export default function useSetVariantIdAttribute() {
  const { reactRoot } = usePageData();

  const {
    state: { variantId },
  } = useWidget();

  useLayoutEffect(() => {
    if (variantId && reactRoot) {
      injectVariantId(reactRoot, variantId);
    }
  }, [reactRoot, variantId]);
}
